var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('span',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.getText())+" ")]):_c('span')}
var staticRenderFns = []

export { render, staticRenderFns }